import { useCookies } from 'react-cookie';
import { TranslationsKeys } from 'store/interfaces';

export const useCurrentLanguage = (): TranslationsKeys => {
  const [cookies] = useCookies(['language_app']);
  return cookies.language_app || 'de';
};
